import { jsx as _jsx } from "react/jsx-runtime";
import { ActionIcon, Indicator, Tooltip, useMantineTheme } from '@mantine/core';
import { getPrimaryColor } from '../column.utils';
export const MRT_TableHeadCellSortLabel = ({ header, table, }) => {
    const { getState, options: { icons: { IconSortDescending, IconSortAscending, IconArrowsSort }, localization, }, } = table;
    const { column } = header;
    const { columnDef } = column;
    const { sorting } = getState();
    const theme = useMantineTheme();
    const sortTooltip = column.getIsSorted()
        ? column.getIsSorted() === 'desc'
            ? localization.sortedByColumnDesc.replace('{column}', columnDef.header)
            : localization.sortedByColumnAsc.replace('{column}', columnDef.header)
        : column.getNextSortingOrder() === 'desc'
            ? localization.sortByColumnDesc.replace('{column}', columnDef.header)
            : localization.sortByColumnAsc.replace('{column}', columnDef.header);
    const showIndicator = sorting.length >= 2 && column.getSortIndex() !== -1;
    return (_jsx(Tooltip, { withinPortal: true, label: sortTooltip, children: _jsx(Indicator, { color: "transparent", disabled: !showIndicator, inline: true, label: column.getSortIndex() + 1, offset: 3, children: _jsx(ActionIcon, { "aria-label": sortTooltip, color: column.getIsSorted() ? getPrimaryColor(theme) : undefined, size: "xs", sx: {
                    opacity: column.getIsSorted() ? 1 : 0.5,
                    transform: showIndicator
                        ? 'translate(-2px, 2px) scale(0.9)'
                        : undefined,
                    transition: 'opacity 100ms ease-in-out',
                    '&:hover': {
                        opacity: 1,
                    },
                }, children: column.getIsSorted() === 'desc' ? (_jsx(IconSortDescending, {})) : column.getIsSorted() === 'asc' ? (_jsx(IconSortAscending, {})) : (_jsx(IconArrowsSort, {})) }) }) }));
};
//# sourceMappingURL=MRT_TableHeadCellSortLabel.js.map